import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function rgbaWithBackgroundToRgb(rgbaColor, backgroundColor) {
  var bgColor = backgroundColor || [255, 255, 255];
  return [Math.round((1 - rgbaColor[3]) * bgColor[0] + rgbaColor[3] * rgbaColor[0]), Math.round((1 - rgbaColor[3]) * bgColor[1] + rgbaColor[3] * rgbaColor[1]), Math.round((1 - rgbaColor[3]) * bgColor[2] + rgbaColor[3] * rgbaColor[2])];
}
export function hexToRgb(hexColor) {
  var bigInt = parseInt(hexColor.slice(1), 16);
  var r = bigInt >> 16 & 255;
  var g = bigInt >> 8 & 255;
  var b = bigInt & 255;
  return [r, g, b];
}
export function rgbToHex(rgbColor) {
  function componentToHex(rgbColorComponent) {
    var hex = rgbColorComponent.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  return "#".concat(componentToHex(rgbColor[0])).concat(componentToHex(rgbColor[1])).concat(componentToHex(rgbColor[2]));
}
export function colorToHex(color) {
  var context = document.createElement('canvas').getContext('2d');
  context.fillStyle = color;
  return context.fillStyle;
}
export function colorWithOpacityToRgb(color, opacity, backgroundColor) {
  var hexColor = colorToHex(color);
  var rgbColor = hexToRgb(hexColor);
  return rgbaWithBackgroundToRgb([].concat(_toConsumableArray(rgbColor), [opacity]), backgroundColor);
}
export function colorWithOpacityToHex(color, opacity, backgroundColor) {
  return rgbToHex(colorWithOpacityToRgb(color, opacity, backgroundColor));
}